// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"225":"f8c477f9","709":"673fbf9e"}[chunkId] + ".chunk.js";
};